import { LeadsPageFilters } from "model/leads-page-filters";

export interface LeadNavigationLocationState {
	// set on a lead record opened from the Lead List (and on its Previous/Next);
	// deep links, notifications and global search leave it unset
	fromLeadList?: boolean;
	// the Lead List search text at the time, which does not survive a reload
	leadListTerm?: string;
	// set on the Lead List when returning to it from a lead record
	leadsPageReturn?: {
		leadId: number;
	};
}

export interface LeadNavigationPosition {
	index: number;
	total: number;
	previousLeadId?: number;
	nextLeadId?: number;
}

export const getLeadNavigationPosition = (
	leadIds: number[],
	leadId: number
): LeadNavigationPosition | undefined => {
	const index = leadIds.indexOf(leadId);
	if (index === -1) {
		return undefined;
	}
	return {
		index,
		total: leadIds.length,
		previousLeadId: index > 0 ? leadIds[index - 1] : undefined,
		nextLeadId: index < leadIds.length - 1 ? leadIds[index + 1] : undefined,
	};
};

export const countLeadsPageFilters = (filters: LeadsPageFilters) => {
	let count = 0;
	Object.keys(filters).forEach((name) => {
		// @ts-ignore
		const value = filters[name];
		if (value instanceof Array) {
			count += value.length;
		} else if (!!value) {
			count++;
		}
	});
	return count;
};
